<template>
    <el-dialog
        :title="'添加邮箱'"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="hanldClose"
        width="500px"
        center>
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px">
            <el-form-item label="邮箱" prop="email">
                <el-input type="text" v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="smtp授权码" prop="code">
                <el-input type="text" v-model="ruleForm.code">
                    <template slot="append">
                        <router-link to="/help?tag=3_266_267&pos=5">如何获取授权码？</router-link>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('ruleForm')">取消
                </el-button>
                <el-button
                    class="padding-lr-xl"
                    type="primary"
                    @click="submitForm('ruleForm')">提交
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>


import {saveEmail} from "@/api/organiz";
import rules from "@/utils/rules";

export default {
    name: "addEmailDialog",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        setItem: {
            type: Object
        }
    },
    data() {
        return {
            ruleForm: {
                code: '',
                email: '',

            },
            rules: {
                email: [
                    {required: true, message: '请输入邮箱', trigger: 'blur'},
                    rules.email
                ],
                code: [
                    {required: true, message: '请输入邮箱smtp授权码', trigger: 'blur'},
                ],

            },
        }
    },
    created() {
    },
    methods: {
        hanldClose() {
            this.$emit('cancelDialog', false)
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await saveEmail( this.setItem ? this.setItem.id : '',this.ruleForm.email, this.ruleForm.code)
            if (_state.status === 200) {
                this.$message.success('编辑成功')
                this.$refs[formName].resetFields();
                this.$emit('cancelDialog', true)
            }
        }
    },
    watch: {
        setItem() {
            this.ruleForm = {
                email: this.setItem ? this.setItem.email : '',
                code: this.setItem ? this.setItem.code : '',
            };
        }
    }
}
</script>

<style scoped lang="scss">
/deep/{
    .el-input-group__append, .el-input-group__prepend{
        padding: 0 3px;
    }
}
</style>